module.exports = __webpack_public_path__ + "img/4.d0fc57c6.jpg";